import { useQuery } from "react-query";
import fetchJson from "./fetchJson";

const useFetchRecipe = (recipeId) => {
  const API_KEY = process.env.REACT_APP_SPOONACULAR_API_KEY;

  const fetchRecipe = async () => {
    const data = await fetchJson(
      `https://api.spoonacular.com/recipes/${encodeURIComponent(
        recipeId
      )}/information?apiKey=${API_KEY}`
    );
    return data;
  };
  return useQuery(["recipe", recipeId], fetchRecipe, {
    refetchOnWindowFocus: false,
    staleTime: 60000, // 1 minute
    cacheTime: 3600000, // 1 hour
  });
};

export default useFetchRecipe;
